import axios, { AxiosPromise } from 'axios'
import {
  ImpressaoRequisicaoExamesSaudeMulherInput,
  ImpressaoSolicitacaoExamesInput,
} from 'view/atendimentos/detail/soap/plano/exames/model-solicitacaoExames'

interface ImpressaoSolicitacaoExameInputModel {
  solicitacoes: ImpressaoSolicitacaoExamesInput[]
  hasMamografia: boolean
  hasCitopatologico: boolean
}

export class ImpressaoSolicitacaoExames {
  imprimirSolicitacaoExames(input: ImpressaoSolicitacaoExameInputModel): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirSolicitacaoExames', input, { responseType: 'blob' })
  }

  imprimirRequisicaoMamografia(input: ImpressaoRequisicaoExamesSaudeMulherInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirSolicitacaoExames/imprimirRequisicaoMamografia', input, {
      responseType: 'blob',
    })
  }

  imprimirRequisicaoCitopatologico(input: ImpressaoRequisicaoExamesSaudeMulherInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirSolicitacaoExames/imprimirRequisicaoCitopatologico', input, {
      responseType: 'blob',
    })
  }
}
